// extracted by mini-css-extract-plugin
export default {"smoothTransition":"smoothTransition-1Qr_yG"};